module.exports = __webpack_public_path__ + "img/animal.02fd83a8.svg";